import { render, staticRenderFns } from "./SchoolBusInfo.vue?vue&type=template&id=663a80ad&scoped=true&"
import script from "./SchoolBusInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolBusInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBusInfo.vue?vue&type=style&index=0&id=663a80ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663a80ad",
  null
  
)

export default component.exports